import {LastServiceInspectionDatePicker} from '../components/LastServiceInspectionDatePicker';
import {LastServiceInspectionMileageInput} from '../components/LastServiceInspectionMileageInput';
import {NextServiceInspectionDatePicker} from '../components/NextServiceInspectionDatePicker';
import {NextServiceInspectionMileageInput} from '../components/NextServiceInspectionMileageInput';
import {ServiceInspectionAfterMileageInput} from '../components/ServiceInspectionAfterMileageInput';
import {ServiceInspectionAfterMonthsInput} from '../components/ServiceInspectionAfterMonthsInput';

export function ServiceInspectionReplacementGroup() {
  return (
    <>
      <LastServiceInspectionDatePicker />
      <LastServiceInspectionMileageInput />
      <NextServiceInspectionDatePicker />
      <NextServiceInspectionMileageInput />
      <ServiceInspectionAfterMonthsInput />
      <ServiceInspectionAfterMileageInput />
    </>
  );
}
